
export const VEHICLE_BRANDS: string[] = [
    'Toyota', 'Ford', 'Mercedes-Benz', 'BMW', 'Audi', 'Tesla', 'BYD', 'TOGG', 'MG', 'Volkswagen',
    'Renault', 'Fiat', 'Opel', 'Peugeot', 'Citroën', 'Hyundai', 'Kia', 'Honda', 'Nissan', 'Dacia',
    'Skoda', 'Seat', 'Cupra', 'Volvo', 'Mazda', 'Mitsubishi', 'Suzuki', 'Subaru', 'Jeep', 'Land Rover',
    'Porsche', 'Mini', 'Alfa Romeo', 'Ferrari', 'Lamborghini', 'Maserati', 'Chery', 'Skywell', 'DFSK'
];

export const CAR_MODELS: Record<string, string[]> = {
    'Toyota': ['Corolla', 'Corolla Cross', 'C-HR', 'RAV4', 'Camry', 'Yaris', 'Yaris Cross', 'Hilux', 'Land Cruiser', 'Prado', 'Highlander', 'Hiace', 'Proace'],
    'Ford': ['Focus', 'Fiesta', 'Kuga', 'Puma', 'EcoSport', 'Mondeo', 'Mustang', 'Transit', 'Tourneo', 'Ranger'],
    'Volkswagen': [
        'Golf 8', 'Golf 7', 'Golf 6', 'Golf 5',
        'Passat B8', 'Passat B7', 'Passat B6',
        'Tiguan II', 'Tiguan I',
        'T-Roc', 'T-Cross', 'Touareg', 'Arteon',
        'ID.7', 'ID.4', 'ID.3', 'ID.5',
        'Transporter'
    ],
    'Mercedes-Benz': ['C Serisi', 'E Serisi', 'S Serisi', 'GLC', 'GLE', 'CLA', 'EQA', 'EQB', 'EQC', 'EQS', 'Vito', 'Sprinter', 'Actros'],
    'BMW': [
        '1 Serisi', '2 Serisi', '3 Serisi', '4 Serisi', '5 Serisi', '7 Serisi',
        'X1', 'X2', 'X3', 'X4', 'X5', 'X6', 'X7',
        'M2', 'M3', 'M4', 'M5', 'M8',
        'i4', 'iX1', 'iX3', 'iX'
    ],
    'Audi': ['A3', 'A4', 'A6', 'Q3', 'Q5', 'Q8', 'e-tron GT', 'e-tron'],
    'Renault': ['Clio', 'Megane', 'Captur', 'Kadjar', 'Arkana', 'Talisman', 'Twingo', 'Kangoo', 'Master', 'Trafic'],
    'Tesla': ['Model Y', 'Model 3', 'Model S', 'Model X', 'Cybertruck'],
    'BYD': ['Atto 3', 'Han', 'Seal', 'Dolphin', 'Tang'],
    'TOGG': ['T10X', 'T10F', 'T10C'],
    'MG': ['ZS', 'HS', '4', '5', 'Marvel R'],
    'Fiat': ['Egea', '500', 'Panda', 'Doblo', 'Ducato'],
    'Hyundai': ['i10', 'i20', 'i30', 'Tucson', 'Kona', 'Santa Fe', 'IONIQ 5', 'IONIQ 6', 'Staria']
};

export const MOTORCYCLE_BRANDS: string[] = [
    'Honda', 'Yamaha', 'Kawasaki', 'Suzuki', 'BMW', 'Ducati', 'Harley-Davidson',
    'KTM', 'Triumph', 'Royal Enfield', 'Moto Guzzi', 'Aprilia', 'MV Agusta',
    'CFMOTO', 'Benelli', 'Kymco', 'SYM', 'Vespa', 'Piaggio', 'Brixton',
    'Fantic', 'GasGas', 'Husqvarna', 'Indian', 'Mutt', 'Scrambler',
    'Zero', 'Energica', 'LiveWire', 'Cake', 'Super Soco', 'NIU'
];

export const MOTORCYCLE_MODELS: Record<string, string[]> = {
    'Honda': ['CBR1000RR-R', 'CB650R', 'CRF1100L Africa Twin', 'CMX500 Rebel', 'Forza 750', 'Forza 250', 'PCX 125'],
    'Yamaha': ['YZF-R1', 'MT-09', 'Tenere 700', 'XMAX 300', 'NMAX 155', 'MT-07', 'YZF-R7'],
    'Kawasaki': ['Ninja ZX-10R', 'Ninja 650', 'Z900', 'Versys 650', 'KLR 650'],
    'BMW': ['R 1250 GS', 'S 1000 RR', 'F 900 R', 'C 400 X', 'CE 04', 'R 1300 GS'],
    'CFMOTO': ['800NK', '450SR', '700CL-X', '800MT', 'Papio'],
    'Ducati': ['Panigale V4', 'Streetfighter V4', 'Multistrada V4', 'Scrambler', 'Monster', 'Diavel'],
    'KTM': ['1290 Super Duke R', '890 Duke R', '390 Duke', '790 Adventure', '250 Duke']
};
